// Реквизиты оператора персональных данных для страниц «Политика конфиденциальности»
// и «Пользовательское соглашение». ПЕРЕД ЗАПУСКОМ заполните значения ниже
// (физическое лицо — ФИО, организация — наименование и ИНН/ОГРН) и покажите тексты юристу.
export const LEGAL = {
  /** Наименование оператора: организатор турниров (организация или ФИО) */
  operatorName: '[УКАЖИТЕ НАИМЕНОВАНИЕ ОПЕРАТОРА]',
  /** ИНН / ОГРН (для организации) или иные реквизиты */
  operatorDetails: '[УКАЖИТЕ ИНН/ОГРН]',
  /** Адрес оператора */
  operatorAddress: '[УКАЖИТЕ АДРЕС]',
  /** Почта для обращений по персональным данным (отзыв согласия, удаление данных) */
  contactEmail: '[УКАЖИТЕ EMAIL ДЛЯ ОБРАЩЕНИЙ]',
  /** Дата последнего обновления документов */
  updatedAt: '17.10.2026',
  siteName: 'JUDO40',
};